export default __webpack_public_path__ + "static/media/THERMAL STRESS.4197cdba.jpg";